import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as Right } from "../../static/arrowRight.svg";
import centurion from "../../static/1_.png";
import centurionCrown from "../../static/1.png";
import centurions from "../../static/2_.png";
import centurionsInst from "../../static/3_.png";
import centurionsCrown from "../../static/2.png";
import IconTint from "react-icon-tint";
import sign from "../../static/logo-new.png";
React.lazy(() => import("./game.scss"));

const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedRegisterMain extends Component {
  render() {
    return (
      <div>
        <div style={{ margin: "0 auto", width: "85%", paddingTop: "64px" }}>
          <div>
            <div style={{ display: "flex" }}>
              <img
                src={sign}
                alt="sign"
                style={{ width: "71px", height: "69px" }}
              />
              <h1 className="register-title">
                Egyedül vagy többen indultok a kalandra?
              </h1>
            </div>
            {/* <p className="register-subtitle">
              Regisztrálj csoportként ha többen vagytok!
            </p> */}
          </div>
        </div>
        <div
          style={{
            margin: "0 auto",
            width: "85%",
            paddingTop: "25px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <NavLink to="/custom">
              <div>
                <div
                  style={{
                    width: "364px",
                    backgroundImage: 'url("' + centurion + '")',
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    //objectFit: "cover",
                    backgroundPosition: "50% 20%",
                    padding: "3em 0 3em 0",
                    textAlign: "center",
                  }}
                >
                  <img
                    alt="centurion"
                    src={centurionCrown}
                    style={{ height: "211px", width: "257px" }}
                  />
                </div>
                <button className="block-button" style={{ marginTop: "55px" }}>
                  Egyéni látogató <Right className="arrow-icon" />
                </button>
              </div>
            </NavLink>
          </div>
          <div>
            <NavLink to="/free">
              <div>
                <div
                  style={{
                    width: "364px",
                    backgroundImage: 'url("' + centurions + '")',
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    //objectFit: "cover",
                    backgroundPosition: "50% 20%",
                    padding: "3em 0 3em 0",
                    textAlign: "center",
                  }}
                >
                  <img
                    alt="centurion"
                    src={centurionsCrown}
                    style={{ height: "211px", width: "257px" }}
                  />
                </div>
                <button className="block-button" style={{ marginTop: "55px" }}>
                  Egyéni csoport <Right className="arrow-icon" />
                </button>
              </div>
            </NavLink>
          </div>
          <div>
            <NavLink to="/institution">
              <div>
                <div
                  style={{
                    width: "364px",
                    backgroundImage: 'url("' + centurionsInst + '")',
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    //objectFit: "cover",
                    backgroundPosition: "50% 20%",
                    padding: "2.786em 0 2.786em 0",
                    textAlign: "center",
                  }}
                >
                  {/* #ECB516 */}
                  {/* <img
                  alt="centurion"
                  src={centurionsCrown}
                  style={{ height: "211px", width: "257px" }}
                /> */}
                  <IconTint
                    src={centurionsCrown}
                    color="#ECB516"
                    style={{ height: "211px", width: "257px" }}
                    maxWidth="257"
                    maxHeight="211"
                  />
                </div>
                <button className="block-button" style={{ marginTop: "55px" }}>
                  Intézményi csoport <Right className="arrow-icon" />
                </button>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const RegisterMain = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedRegisterMain);
export default RegisterMain;
